import { RotatingLines } from "react-loader-spinner";

const Loader = () => {
  return (
    <div>
      <RotatingLines
        strokeColor="#28303f"
        strokeWidth="5"
        animationDuration="0.75"
        width="90"
        visible={true}
      />
    </div>
  );
};

export default Loader;
